// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/bindings/common/Uuid.mjs";
import * as GaPublisher$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/react-ga/publishers/GaPublisher.mjs";
import * as CommonStore$PorterinFeature from "../../../containers/enterprise/domain/store/CommonStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../containers/fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as EventsTrackerHelper$PorterinFeature from "./EventsTrackerHelper.mjs";

function publishGa4Events(category, action, label) {
  EventsTrackerHelper$PorterinFeature.publishEvent({
        category: category,
        action: action,
        label: label,
        value: undefined,
        nonInteraction: undefined
      });
}

var publishEvents = publishGa4Events;

var publishEventsV2 = GaPublisher$PorterinUtils.publishGaEventParameter;

function fireCategoryCompareEvent(service_type) {
  var uuid = Uuid$PorterinUtils.generatedUuid(undefined);
  EventsTrackerHelper$PorterinFeature.publishEventParameter(CommonStore$PorterinFeature.compareEventLabel, {
        web_tracking_id: CookieUtils$PorterinFeature.webTrackingIdSafely(undefined),
        service_type: service_type,
        service_card_id: uuid
      });
}

function serviceShortName(service) {
  var match = service.toLocaleLowerCase();
  switch (match) {
    case "all india parcel" :
    case "courier" :
    case "courier service" :
    case "courier services" :
    case "intercity" :
    case "intercity courier service" :
        return "courier";
    case "packers & movers" :
    case "packers and movers" :
    case "pnm" :
        return "pnm";
    case "truck" :
    case "trucks" :
        return "truck";
    case "two wheeler" :
    case "two wheelers" :
        return "2w";
    default:
      return service.toLocaleLowerCase();
  }
}

function publishCategoryCardEvent(category, category_card, link) {
  var service = serviceShortName(category_card);
  publishGa4Events(category, "fe_home_" + service + "_tap", link);
}

function publishFareEstimateCategoryCardEvent(category, category_card, link) {
  var service = serviceShortName(category_card);
  publishGa4Events(category, "fe_homegetest_" + service + "_tap", link);
}

export {
  publishGa4Events ,
  publishEvents ,
  publishEventsV2 ,
  fireCategoryCompareEvent ,
  serviceShortName ,
  publishCategoryCardEvent ,
  publishFareEstimateCategoryCardEvent ,
}
/* Uuid-PorterinUtils Not a pure module */
